import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { IDENTITY_ACCESS_TOKEN_EXPIRING_NOTIFICATION_TIME } from '../constants/authConstants';
import userActivity from '../redux/actions/userActivityAction';

const useUserActivity = () => {
  const dispatch = useDispatch();
  const modalType = useSelector(state => state.modal.modalType);
  const sessionTimeOutModalVisibility = useSelector(state => state.modal.isOpened);

  // ? Retirar comentários da linha 12 até 19
  // ? caso queira calcular dinamicamente o tempo máximo de inatividade do usuário
  // const user = useSelector(state => state.auth.user);
  // const [identityAcessTokenExpiringTime, setIdentityAcessTokenExpiringTime] = useState(null);

  // useEffect(() => {
  //   if (user) {
  //     setIdentityAcessTokenExpiringTime(user.expire);
  //   }
  // }, [user]);

  const [isActive, setIsActive] = useState(false);
  let secondsSinceLastActivity = 0;

  // ? Retirar comentários da linha 26 até 27
  // ? caso queira calcular dinamicamente o tempo máximo de inatividade do usuário
  // eslint-disable-next-line max-len
  // const maxInactivity = identityAcessTokenExpiringTime ? identityAcessTokenExpiringTime - IDENTITY_ACCESS_TOKEN_EXPIRING_NOTIFICATION_TIME : 60 * 5;
  const maxInactivity = 60 * 5; // 5 minutos

  // A cada segundo checa se o usuário está inativo
  // e se ele estiver muda o state para false
  setInterval(() => {
    secondsSinceLastActivity += 1;
    if (secondsSinceLastActivity > maxInactivity) {
      setIsActive(false);
    }
  }, 1000);

  // Reseta o contador e muda o state para true
  const activity = () => {
    secondsSinceLastActivity = 0;
    setIsActive(true);
  };

  // Lista de events que contam como atividade
  const activityEvents = [
    'mousedown', 'mousemove', 'keydown',
    'scroll', 'touchstart',
  ];

  // Adiciona listeners para os eventes e chama o metodo
  // activity caso um deles ocorra
  activityEvents.forEach((eventName) => {
    document.addEventListener(eventName, activity, true);
  });

  // Use effect que modifica o state global usando redux
  // cada vez que o valor de isActive muda
  // Porém, enquanto o modal de ssesion timeout estiver aparecendo,
  // a atividade do usuário fica como false até ele clicar no botão para continuar logado
  // se não clicar a tempo, é redirecionado para o login
  useEffect(() => {
    if (!sessionTimeOutModalVisibility && modalType === 'SESSION_TIMEOUT') {
      dispatch(userActivity(isActive));
    }
  }, [isActive, sessionTimeOutModalVisibility]);

  return isActive;
};

export default useUserActivity;
